export default (text) => {
  if (typeof text === 'string') {
    return text.replace(/(&#8220;|&#8221;|&#8243;|″|"|”|“)/g, '"')
  }

  return text
}

